import React, { useState } from "react";
import { IResourceComponentsProps, useParsed } from "@refinedev/core";

import { useModal } from "components/Modal";
import { UnAvailableHouseRecordForm } from "components/form/UnAvailableHouseRecordForm";
import { FormShowComponent } from "components/form/FormShowComponent";

export const FormShow: React.FC<IResourceComponentsProps> = (props) => {
  const { Modal, open } = useModal({ defaultOpen: true });

  const parsedData = useParsed();
  const isResponse = !!parsedData.params?.responseId;
  const isRedirectedFromRecords = !!parsedData.params?.recordId;

  const [isAvailable, setIsAvailable] = useState(false);

  if (open && !isResponse && !isRedirectedFromRecords) {
    return (
      <Modal
        id="is-family-available"
        title="के डाटा रेकर्ड गर्न परिवारको कुनै सदस्य उपलब्ध छ?"
        okTitle="छ"
        cancelTitle="छैन"
        onOk={() => setIsAvailable(true)}
      />
    );
  }
  return isAvailable || isResponse || isRedirectedFromRecords ? (
    <FormShowComponent {...props} />
  ) : (
    <UnAvailableHouseRecordForm {...props} />
  );
};
